export class CodedLookup {

    constructor(){}

    CodeValue: string;
    Description: string;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/coded.model.ts